var paymentOverlay = '<div id="stripeoverlay" style="position: fixed; filter: alpha(opacity=80); top: 0px; left: 0px; width: 100%; height: 100%; display: block; opacity: 0.7; z-index: 10001; background-color: black;"><div style="color: #fff; font-size: 17px; font-weight: bolder;position:absolute; width: 160px;margin-left: -80px; margin-top: -30px; top: 50%; text-align: center;left:50%;">Payment in progress<br><img style="margin-top:10px" src="data:image/gif;base64,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"/></div></div>';

// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------

const COUNTRY_ITALIA = 108;

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

/**
 * Sets visibility and the disabled state of a group of jQuery-selected elements.
 * @param {jQuery} $elements
 * @param {boolean} visible
 */
function setFieldGroupVisibility($elements, visible) {
    if (visible) {
        $elements.show(0).find('input').prop('disabled', false);
    }
    else {
        $elements.hide(0).find('input').prop('disabled', true);
    }
}

/**
 * Triggers a GTM payment event and then submits the given form.
 * Falls back to a plain submit when dataLayer is unavailable.
 * @param {HTMLFormElement} form
 * @param {string} paymentMethod  Label passed to the ecommerce helper (e.g. "Booking", "COD").
 */
function payWithMethod(form, paymentMethod) {
    if (window.dataLayer) {
        event.preventDefault();
        event.stopPropagation();
        dataLayer.push({ ecommerce: null });
        pushGTMEventWithCallback(500, {
            event: 'add_payment_info',
            ecommerce: window.ecommerce(paymentMethod),
            eventCallback: GTMCallback(function() {
                if (form.requestSubmit) {
                    form.requestSubmit();
                }
                else {
                    form.submit();
                }
            })
        });
    }
    else {
        form.submit();
    }
}

/**
 * POSTs a single key/value checkout property.
 * @param {string} key
 * @param {string} value
 * @param {Function} [complete]  Optional callback invoked when the request finishes.
 * @returns {jqXHR}
 */
function setProperty(key, value, complete) {
    return $.ajax({
        url: '/restful/shopping/public/checkout/setproperty',
        method: 'POST',
        data: { key, value },
        complete: complete
    });
}

// ---------------------------------------------------------------------------
// Document ready
// ---------------------------------------------------------------------------

$(document).ready(function() {
    'use strict';

    // --- Invoice type visibility -------------------------------------------

    function checkInvoiceType() {
        const type = $('#type-invoice').val();
        const $allInvoiceFields = $('#fiscal_code-div, #cfpiva-div, #pec-div, #sdi-div');

        setFieldGroupVisibility($allInvoiceFields, false);

        if (type === 'privato') {
            setFieldGroupVisibility($('#fiscal_code-div'), true);
        }
        else if (type === 'azienda') {
            setFieldGroupVisibility($('#cfpiva-div, #pec-div, #sdi-div'), true);
        }
    }

    $('#type-invoice').on('change', checkInvoiceType);
    checkInvoiceType();

    // --- PEC / SDI visibility based on country + invoice type --------------

    $('#billing-address-form #country, #type-invoice').on('change', function() {
        if ($('#type-invoice').val() !== 'azienda') return;

        const isItaly = parseInt($('#country').val()) === COUNTRY_ITALIA;
        $('#pec-div, #sdi-div').toggleClass('hide', !isItaly);
        $('#pec, #sdi').prop('disabled', !isItaly);
    });

    // --- Checkbox sync -----------------------------------------------------

    $('#clausola').on('click', function() {
        $('#clausola1')[0].checked = this.checked;
    });

    // --- Next-step routing from radio buttons ------------------------------

    $('[name="fattura-richiesta"]').on('change', function() {
        if (this.checked) {
            const form = this.closest('form');
            form.dataset.nextstep = this.dataset.nextstep ?? form.dataset.nextstep;
        }
    });

    // --- Address form validation -------------------------------------------

    const addressFormValidationOptions = {
        rules: {
            addressee: {
                required: true,
                minlength: 3
            }
        },
        messages: {
            addressee: {
                minlength: msg['ERR_MIN_LENGTH']
                    .replace(':field', '')
                    .replace(':length', 3)
                    .replace('  ', ' ')
            }
        },
        errorPlacement: function(error, element) {
            const type = $(element).attr('type');
            if (type === 'radio') {
                $(error).insertAfter(element.closest('.radio'));
            }
            else if (type !== 'checkbox') {
                $(error).insertAfter(element);
            }
        },
        submitHandler: submitAddressForm,
        invalidHandler: function() {
            if ($('[name="addressee"]').is('.error')) {
                const name = $('[name="addressee"]')
                    .parent().find('label').not('.error').text()
                    .replace(' *', '').toUpperCase();
                showMessageBox('danger', msg['ERR_MIN_LENGTH'].replace(':field', name).replace(':length', 3));
            }
            else {
                showMessageBox('danger', msg['ERR_MISSINGFIELDS']);
            }
        }
    };

    $('#dispatch-address-form, #billing-address-form').validate(addressFormValidationOptions);

    // --- Address form submission -------------------------------------------

    function submitAddressForm(form) {
        const $form = $(form);
        const $pec = $('#pec');
        const $sdi = $('#sdi');
        const countryVal = parseInt($('#country').val());

        const pecSdiRequired =
            countryVal === COUNTRY_ITALIA &&
            $pec.is(':visible') &&
            $sdi.is(':visible') &&
            !($pec.val() || $sdi.val());

        if (pecSdiRequired) {
            showMessageBox('danger', msg['ERR_PEC_OR_SDI_REQUIRED']);
            return;
        }

        const isDispatchForm = $form.is('#dispatch-address-form');

        // Collect disabled fields as empty key=value pairs so the server
        // receives them and can clear previously-saved values.
        const emptyFields = $form.find('input[name]:disabled').toArray()
            .map(input => `${$(input).attr('name')}=`)
            .join('&');

        $.ajax({
            method: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize() + '&' + emptyFields,
            dataType: 'json',
            success: function(data) {
                if (data.success) {
                    handleAddressSuccess($form, isDispatchForm);
                }
                else {
                    showMessageBox('danger', msg[data.errors.message] || data.errors.message);
                }
            },
            error: function() {
                showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
            }
        });
    }

    /**
     * Runs post-save logic after a successful address AJAX call, including
     * GTM events and checkout property persistence.
     */
    function handleAddressSuccess($form, isDispatchForm) {
        const redirect = buildRedirectFn($form, isDispatchForm);

        if (isDispatchForm) {
            handleDispatchFormSuccess(redirect);
        }
        else {
            handleBillingFormSuccess(redirect);
        }
    }

    /** Returns a function that navigates to the form's next step, firing a GTM event first if needed. */
    function buildRedirectFn($form, isDispatchForm) {
        const nextStep = () => { window.location.href = $form.data('nextstep'); };

        if (!isDispatchForm || !window.dataLayer) return nextStep;

        return function() {
            dataLayer.push({ ecommerce: null });
            pushGTMEventWithCallback(500, {
                event: 'add_shipping_info',
                ecommerce: window.ecommerce,
                eventCallback: GTMCallback(nextStep)
            });
        };
    }

    function handleDispatchFormSuccess(redirect) {
        const $needInvoice = $('[name="fattura-richiesta"]:checked');

        if ($needInvoice.length === 0) {
            redirect();
            return;
        }

        setProperty($needInvoice.attr('name'), $needInvoice.val(), function() {
            if ($needInvoice.val() === 'no') {
                setProperty('type-invoice', 'ricevuta', () => {
                    setProperty('in-payment', 'true', redirect);
                });
            }
            else {
                redirect();
            }
        });
    }

    function handleBillingFormSuccess(redirect) {
        const $invoiceType = $('#type-invoice');

        if ($invoiceType.length === 0) {
            redirect();
            return;
        }

        setProperty($invoiceType.attr('name'), $invoiceType.val(), () => {
            setProperty('in-payment', 'true', redirect);
        });
    }

    // --- Copy dispatch address to billing address --------------------------

    const fieldsToCopy = ['addressee', 'cap', 'city', 'number', 'prov', 'street', 'country'];

    $('#copy-dispatch').on('click', function() {
        fieldsToCopy.forEach(function(field) {
            $(`#${field}`).val($(`#${field}_disp`).val());
        });
    });

    // --- Province dropdowns ------------------------------------------------

    $('[name*="country"]').on('change', updateProvinces);
    updateProvinces();

    function updateProvinces() {
        $('[name*="prov"]').each(function() {
            const $prov = $(this);
            const $country = $prov.closest('form').find('[name*="country"]');

            if ($country.length === 0) return;

            loadProvinces($country.val()).then(function(provinces) {
                if (provinces.length > 0) {
                    replaceProvWithSelect($prov, provinces);
                }
                else if ($prov.is('select')) {
                    replaceSelectWithInput($prov);
                }
            });
        });
    }

    function replaceProvWithSelect($prov, provinces) {
        const currentValue = $prov.val();
        let hasSelectedValue = false;

        const options = provinces.map(function(province) {
            const selected = province.code === currentValue ? 'selected' : '';
            hasSelectedValue = hasSelectedValue || province.code === currentValue;
            return `<option value="${province.code}" ${selected}>${province.name} (${province.code})</option>`;
        });

        if (!hasSelectedValue && options.length > 0) {
            options[0] = options[0].replace('  ', ' selected');
        }

        $prov.replaceWith(`
            <select id="${$prov.attr('id')}" name="${$prov.attr('name')}"
                    data-type="${$prov.attr('type')}" data-placeholder="${$prov.attr('placeholder')}"
                    data-value="${currentValue}" required aria-required="true">
                ${options.join('\n')}
            </select>
        `);
    }

    function replaceSelectWithInput($prov) {
        $prov.replaceWith(`
            <input id="${$prov.attr('id')}" type="${$prov.data('type')}"
                   name="${$prov.attr('name')}" value="${$prov.data('value')}"
                   placeholder="${$prov.data('placeholder')}" required aria-required="true"/>
        `);
    }

    // --- SDI field sanitisation --------------------------------------------

    $('input[name*="sdi"]').on('input', function() {
        $(this).val($(this).val().replace(/[^a-zA-Z0-9]/g, '').toUpperCase());
    });

    // --- Booking / COD confirmation buttons --------------------------------

    $('#booking-btn').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        showQuestionBox(msg['MSG_CONFIRM_BOOKING'], null, payWithBooking);
    });

    $('#cod-btn').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        showQuestionBox(msg['MSG_CONFIRM_COD'], null, payWithCOD);
    });

    // --- Reset cart form ---------------------------------------------------
    document.getElementById("reset-cart-form").addEventListener("submit", (event) => {
        event.preventDefault();


        const form = event.target;
        showQuestionBox(msg['MSG_CONFIRM_CART_RESET'], null, () => {
            $.ajax({
                method: form.method,
                url: form.action,
                data: $(form).serialize(),
                dataType: "json",
                success: function(data) {
                    if (data.success) {
                        window.location.href = form.dataset.nexturl;
                    }
                    else {
                        showMessageBox("danger", msg["ERR_CART_RESET"]);
                    }
                },
                error: function() {
                    showMessageBox("danger", msg["MSG_GENERIC_ERROR"]);
                }
            });
        });
    });
});

// ---------------------------------------------------------------------------
// reCAPTCHA callbacks (called from inline HTML attributes)
// ---------------------------------------------------------------------------

function vatReliefFormSubmit() {
    $('#vat-relief-form [type="submit"]').prop('disabled', false);
}

function vatReliefFormExpired() {
    $('#vat-relief-form [type="submit"]').prop('disabled', true);
    grecaptcha.reset();
}

// ---------------------------------------------------------------------------
// Payment method handlers (called from showQuestionBox callbacks)
// ---------------------------------------------------------------------------

function payWithBooking() {
    payWithMethod(document.getElementById('booking-btn').closest('form'), 'Booking');
}

function payWithCOD() {
    payWithMethod(document.getElementById('cod-btn').closest('form'), 'COD');
}